import { FC, useEffect } from 'react'
import useIsTelegram from 'utils/hooks/useIsTelegram'

import { useTranslation } from 'next-i18next'

import { CloseIcon } from 'components/Images/Icons'

import styles from './InAppBrowserModal.module.scss'

interface IInAppBrowserModal {
  visible: boolean
  onClose: () => void
}

const InAppBrowserModal: FC<IInAppBrowserModal> = ({ visible, onClose }) => {
  const [t] = useTranslation(['main'])
  const { os, copied, openInExternalBrowser, copyLink } = useIsTelegram()

  useEffect(() => {
    const onKeydown = ({ key }: KeyboardEvent) => {
      if (key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKeydown)
    return () => document.removeEventListener('keydown', onKeydown)
  }, [onClose])

  if (!visible) return null

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
          <CloseIcon />
        </button>

        <h3 className={styles.title}>{t('main:inAppBrowserTitle')}</h3>
        <p className={styles.text}>{t('main:inAppBrowserText')}</p>

        {os === 'ios' && <p className={styles.hint}>{t('main:inAppBrowserIosHint')}</p>}

        <div className={styles.actions}>
          {os !== 'other' && (
            <button type="button" className={styles.primary} onClick={openInExternalBrowser}>
              {t('main:inAppBrowserOpenBtn')}
            </button>
          )}

          <button type="button" className={styles.secondary} onClick={copyLink}>
            {copied ? t('main:inAppBrowserCopied') : t('main:inAppBrowserCopyLink')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default InAppBrowserModal
